import { useCurrentUser } from "utils/hooks";

const useRecordResourceView = () => {
  const { user } = useCurrentUser();

  const recordResourceView = (
    resourceId: string,
    resourceType: "link" | "file" | "assignment"
  ) => {
    if (user?.type !== "patient" || !resourceId || !resourceType) return null;

    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
              mutation {
                recordResourceClick (
                  resourceId: "${resourceId}"
                  resourceType: "${resourceType}"
                ) {
                    actionStats {
                        uuid
                        organizationId
                        resourceId
                        assignmentType
                        patientId
                        actionStatus
                        assigned_by
                        assigned_by_role
                        assigned_at
                        hasNotification
                        notificationId
                        createdAt
                    }
                    error
                }
              }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_links",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            return false;
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.error) {
            return false;
          }
          return true;
        });
    });
  };

  return { recordResourceView };
};

export default useRecordResourceView;
